export default "__VITE_ASSET__5V7Rs6zS__"